import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getProjectById } from '../../store/slices/projectSlice';
import './stats.scss';
import Statstab from './statstab';

export default function Stats() {
  const { projectId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (projectId) {
      // Always fetch to ensure we have the specific settings for this bot
      // This fixes the issue where switching bots kept the old bot's settings in focus
      dispatch(getProjectById({ id: projectId }));
    }
  }, [projectId, dispatch]);

  return (
    <div>
      <Statstab />
    </div>
  )
}

